import React, { useState } from "react";

import { MdDelete } from "react-icons/md";
import { MdIncompleteCircle, MdOutlineDoneOutline } from "react-icons/md";
import { FaRegCaretSquareDown, FaRegCaretSquareUp } from "react-icons/fa";
import {
  Card as MuiCard,
  CardContent,
  Typography,
  Box,
  Collapse,
} from "@mui/material";
import styled from "styled-components";
// import { format } from "date-fns";
import TodoItem from "./TodoItem";
import NewItemInput from "./InputItem";
import API from "../../../utils/api";

// const DateTypography = styled(Typography)`
//   font-size: 1rem;
//   font-style: italic;
//   margin-top: 0.5rem;
//   color: lightgray;
//   text-align: right;
// `;
const Card = styled(MuiCard)`
  background-color: #1b1a2ea9 !important;
  color: white;
  box-shadow: 0 0px 3px 3px #ebc2f575;
  transition: all 0.5s ease 0s;
  margin-top: 0.7rem;
  height: auto;

  @media (max-width: 600px) {
    width: 100%; /* Take almost full width on mobile */
  }
`;

const ContentBox = styled(Box)`
  color: white;
  font-size: 1rem;
  line-height: 1.5;
  text-align: left;
  font-family: "Montserrat", sans-serif;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 600px) {
    font-size: 0.9rem; /* Reduced font size for better mobile readability */
    line-height: 1.3;
  }
`;

const ExpandButton = styled(Typography)`
  color: #fff;
  margin-left: 1rem;
  &:hover {
    background-color: #6d20c5d7;
  }

  @media (max-width: 600px) {
    font-size: 0.9rem; /* Smaller button text size */
    margin-left: 0.5rem; /* Reduced margin for smaller screens */
  }
`;

const NameTypography = styled(Typography)`
  font-size: 1.3rem;
  text-align: left;

  padding-left: 1.2rem;
  width: 100%;
  color: #ffcc99;

  @media (max-width: 600px) {
    font-size: 1rem;
    padding-left: 0.5rem;
  }
`;

// const CountTypography = styled(Typography)`
//   font-size: 1.2rem;
//   color: var(--imp-text-color);

//   @media (max-width: 600px) {
//     font-size: 1rem; /* Adjusted for mobile */
//   }
// `;

const ToggleButton = styled(Typography)`
  color: white;
  padding-top: 0;
  @media (max-width: 600px) {
    font-size: 0.9rem; /* Adjust font size for mobile screens */
  }
`;

const TodoCard = ({ edit, cards, items, card, refresh }) => {
  const [expanded, setExpanded] = useState(false);
  const [hidden, setHidden] = useState(false);
  // Toggle expanded state for collapsing/expanding the sub-items
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const deleteItem = () => {
    API.post("/api/learning/deleteItem", {
      _id: card._id,
      type: "card",
      parentId: card.parentId,
    })
      .then((req) => req.data)
      .then((data) => {
        alert(data.message);
        setHidden(true);
      })
      .catch((e) => {
        alert("Error: ", e);
      });
  };

  // const formatDate = (date) => {
  //   return format(new Date(date), "EEE, do MMM yyyy");
  // };
  return (
    <Card hidden={hidden}>
      <CardContent sx={{ padding: ".7rem !important" }}>
        <Box display="flex" justifyContent="space-between" alignItems="left">
          {" "}
          <ToggleButton>
            {card.done ? (
              <>
                <MdOutlineDoneOutline color="#1fe46a" fontSize="150%" />
              </>
            ) : (
              <>
                <MdIncompleteCircle color="#a986ad" fontSize="150%" />
              </>
            )}
          </ToggleButton>
          <NameTypography onClick={handleExpandClick}>
            {card.name}
          </NameTypography>
          <Box display="flex" alignItems="center">
            {edit && !card.done ? (
              <Typography>
                <MdDelete
                  color="#a986ad"
                  font-size="150%"
                  onClick={deleteItem}
                />
              </Typography>
            ) : (
              <ExpandButton onClick={handleExpandClick}>
                {expanded ? (
                  <FaRegCaretSquareUp color="#a986ad" font-size="180%" />
                ) : (
                  <FaRegCaretSquareDown color="#a986ad" font-size="180%" />
                )}
                {"  "}
              </ExpandButton>
            )}
          </Box>
        </Box>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box display="flex" justifyContent="center" flexDirection="column">
            <ContentBox sx={{ paddingTop: ".7rem" }}>
              {/* <DateTypography hidden>{`Date: ${formatDate(
                props.date
              )}`}</DateTypography> */}
              {card.subItems.map((item, index) =>
                item.type === "item" ? (
                  <TodoItem
                    key={index}
                    item={items[item._id]}
                    items={items}
                    edit={edit}
                  />
                ) : (
                  <TodoCard
                    key={index}
                    edit={edit}
                    cards={cards}
                    items={items}
                    card={cards[item._id]}
                    refresh={refresh}
                  />
                )
              )}
              {edit && <NewItemInput parent={card._id} refresh={refresh} />}
            </ContentBox>
            <Box display="flex" justifyContent="center"></Box>
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
};

export default TodoCard;
